export default {
  offerStatusesList: []
}
